/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import "./table.scss";
import { BiLeftArrow, BiRightArrow } from "react-icons/bi";
import { getAuthToken } from "../../services/Auth";
import axios from "axios";
import { DOWNLOADORDERSOPCLOSED, DOWNLOADORDERSOPEN, DOWNLOADREPORTSTOCK, DOWNLOADSTOCKCOMPPART, DOWNLOADSTOCKMP, DOWNLOADSTOCKPRODACABADO, GETREPORTSTOCK, ORDEROPENORCLOSED, STOCKGET, GETEXPEDITIONGUIDE, GETEXPEDITIONGUIDEINFO, INFO_BY_EXPEDITION_GUIDE, INFO_BY_EXPEDITION_GUIDE_CSV, INFO_BY_SHIPMENT_MANIFEST_CSV, GETSHIPMANIFESTINFO, GETSHIPMANIFEST, INFO_BY_SHIPMENT_MANIFEST } from "../../constants/endpoints";
import { useDispatch, useSelector } from "react-redux";
import { RingLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaFileCsv, FaFileExcel } from "react-icons/fa6";
import { logoutSelectedCompany } from "../../Store/modules/selectedCompany";
import { logoutSelectedMoreCompany, setSelectedMoreCompany } from "../../Store/modules/selectedMoreAbout";
import { logoutSelectedLink } from "../../Store/modules/selectedLinkSlice";
import { SendRequest } from "../../function/General_Functions";
import { useTranslation } from "react-i18next";
import { FaInfoCircle } from "react-icons/fa";
import MessageToUse from "../messagesToUse/MessagesToUse";
import { articleInformation } from "../messagesToUse/list";
import ModalWait from "../ModalWait/ModalWait";


const ICON_SIZE = 18;
const ITEMS_PER_PAGE = 20;

function TableToUse(props) {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const selectedCompany = useSelector((state) => state.selectedCompany.data);
    const selectedLink = useSelector((state) => state.selectedLink.data);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [infoTable, setInfoTable] = useState([])
    const [columnNames, setColumnNames] = useState([]);
    const [stateTable, setStateTable] = useState("")
    const [loading, setLoading] = useState(true);
    const selectedLanguage = useSelector((state) => state.selectedLanguage.data);
    const [seeBalloon, setSeeBalloon] = useState(false)
    const { t } = useTranslation();
    const balloonRef = useRef(null);
    const [searchByName, setSearchByName] = useState("");
    const [filterBy, setFilterBy] = useState("");
    const [isChecked, setIsChecked] = useState(0);
    const [isCheckedSecond, setIsCheckedSecond] = useState(0);
    const [isCheckedThird, setIsCheckedThird] = useState(0);
    const [dateEpStart, setDateEpStart] = useState("");
    const [dateEpEnd, setDateEpEnd] = useState("");
    const [isDate, setIsDate] = useState(false);
    const [dateEfStart, setDateEfStart] = useState("");
    const [dateEfEnd, setDateEfEnd] = useState("");
    const [modalWaitShow, setModalWaitShow] = useState(false);
    const [expandedRow, setExpandedRow] = useState(null);
    const [subTableData, setSubTableData] = useState([]);
    const [loadingSubTable, setLoadingSubTable] = useState(false);
    const [downloadingRow, setDownloadingRow] = useState(null);


    // Function to navigate to a specific page
    const goToPage = (targetPage) => {
        //console.log("targetPage", targetPage);
        if (targetPage >= 1 && targetPage <= totalPages) {
            setPage(targetPage);
        }
    };

    // Initial setup based on selected link
    useEffect(() => {
        setStateTable(selectedLink?.nameToSelect)
        console.log(selectedLink?.name);
    }, [selectedLink?.nameToSelect]);

    // Effect to fetch data based on page change
    useEffect(() => {
        if ((selectedLink?.name === "Encomendas" || selectedLink?.name === "Artigos em Stock" || selectedLink?.name === "Relatório de Stocks" || selectedLink?.name === "Detalhes do Envio" || selectedLink?.name === "Manifestos de Carga") && selectedCompany?.id !== "" && stateTable !== "" && selectedLanguage?.lang !== "") {
            getOrdersOpenOrClosed();
        }
        setInfoTable([]);
        setExpandedRow(null);
        setSubTableData([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);

    // Effect to fetch data based on company, state, and language change
    useEffect(() => {
        if (page > 1) {
            setPage(1)
        } else {
            if ((selectedLink?.name === "Encomendas" || selectedLink?.name === "Artigos em Stock" || selectedLink?.name === "Relatório de Stocks" || selectedLink?.name === "Detalhes do Envio" || selectedLink?.name === "Manifestos de Carga") && selectedCompany?.id !== "" && stateTable !== "" && selectedLanguage?.lang !== "" && isChecked !== "") {
                getOrdersOpenOrClosed();
            }
            setInfoTable([]);
            setExpandedRow(null);
            setSubTableData([]);
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCompany, stateTable, selectedLanguage, isChecked, isCheckedSecond, isCheckedThird]);

    // Function to handle row click to either expand details or navigate
    const handleRowClick = async (index, value) => {
        if (selectedLink?.name === "Detalhes do Envio" || selectedLink?.name === "Manifestos de Carga") {
            if (expandedRow === index) {
                setExpandedRow(null);
                setSubTableData([]);
                return;
            }

            setExpandedRow(index);
            setLoadingSubTable(true);
            setSubTableData([]);

            if (selectedLink?.name === "Detalhes do Envio") {
                try {
                    const token = getAuthToken();
                    const expGuide = value["Document"] || value["Documento"] || Object.values(value)[0];
                    const response = await axios.get(`${INFO_BY_EXPEDITION_GUIDE}${expGuide}&client_id=${selectedCompany.id}`, {
                        headers: { Authorization: `token ${token}`, 'Accept-Language': selectedLanguage?.lang },
                    });

                    if (response.status === 200) {
                        setSubTableData(response.data.result || []);
                    }
                } catch (error) {
                    console.error("Error fetching sub-table details:", error);
                    toast.error(t("ship_detail_err"));
                } finally {
                    setLoadingSubTable(false);
                }
            }
            else if (selectedLink?.name === "Manifestos de Carga") {
                try {
                    const token = getAuthToken();
                    const shipManif = value["Document"] || value["Documento"] || Object.values(value)[0];
                    const response = await axios.get(`${INFO_BY_SHIPMENT_MANIFEST}${shipManif}&client_id=${selectedCompany.id}`, {
                        headers: { Authorization: `token ${token}`, 'Accept-Language': selectedLanguage?.lang },
                    });

                    if (response.status === 200) {
                        setSubTableData(response.data.result || []);
                    }
                } catch (error) {
                    console.error("Error fetching sub-table details:", error);
                    toast.error(t("manifest_detail_err"));
                } finally {
                    setLoadingSubTable(false);
                }
            }
        } else {
            moreInfo(value);
        }
    };

    // Function to show more info about a specific item
    const moreInfo = (value) => {
        //console.log("value", value);
        if (selectedLink?.name === "Encomendas") {
            navigate(`/pages/MoreAbout/${value?.ID}`)
            //console.log(value);
            dispatch(
                setSelectedMoreCompany({
                    data: {
                        value
                    }
                })
            )
        }
        //console.log("nao vai");
    }

    // Download CSV for a specific expedition guide row
    const downloadExpeditionCsv = async (e, expGuide, separator = ",") => {
        e.stopPropagation(); // prevent sub-table from toggling
        setDownloadingRow(expGuide);
        try {
            const token = getAuthToken();
            const response = await axios.get(
                `${INFO_BY_EXPEDITION_GUIDE_CSV}${encodeURIComponent(expGuide)}&client_id=${selectedCompany.id}&delimiter=${encodeURIComponent(separator)}`,
                {
                    headers: { Authorization: `token ${token}`, 'Accept-Language': selectedLanguage?.lang },
                    responseType: 'blob',
                }
            );
            if (response.status === 200) {
                const safeGuide = String(expGuide).replace(/[/\\]/g, '_');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.download = separator === "\t" ? `expedition_${safeGuide}_excel.csv` : `expedition_${safeGuide}.csv`;
                link.click();
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error('Error downloading expedition CSV:', error);
            toast.error(t('csv_download_err'));
        } finally {
            setDownloadingRow(null);
        }
    };

    // Download CSV for a specific shipment manifest row
    const downloadShipmentManifestCsv = async (e, shipManif, separator = ",") => {
        e.stopPropagation(); // prevent sub-table from toggling
        setDownloadingRow(shipManif);
        try {
            const token = getAuthToken();
            const response = await axios.get(
                `${INFO_BY_SHIPMENT_MANIFEST_CSV}${encodeURIComponent(shipManif)}&client_id=${selectedCompany.id}&delimiter=${encodeURIComponent(separator)}`,
                {
                    headers: { Authorization: `token ${token}`, 'Accept-Language': selectedLanguage?.lang },
                    responseType: 'blob',
                }
            );
            if (response.status === 200) {
                const safeManifest = String(shipManif).replace(/[/\\]/g, '_');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.download = separator === "\t" ? `manifest_${safeManifest}_excel.csv` : `manifest_${safeManifest}.csv`;
                link.click();
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error('Error downloading shipment manifest CSV:', error);
            toast.error(t('csv_download_err'));
        } finally {
            setDownloadingRow(null);
        }
    };
    // GET CSV for Download
    let isRequestInProgress = true
    const getCsvFileDownload = async (separator = ",") => {
        if (isRequestInProgress === true) {
            isRequestInProgress = false
            setModalWaitShow(true)
            try {
                const token = getAuthToken();
                let apiUrl, state, stateToUrl;

                if (stateTable === "open") {
                    console.log("open");
                    apiUrl = `${DOWNLOADORDERSOPEN}${selectedCompany.id}`;
                    state = "open";
                    stateToUrl = "Orders"
                } else if (stateTable === "mp") {
                    apiUrl = `${DOWNLOADSTOCKMP}${selectedCompany.id}`;
                    state = "mp";
                    stateToUrl = "Stock"
                    console.log("mp");
                } else if (stateTable === "prodacabado") {
                    apiUrl = `${DOWNLOADSTOCKPRODACABADO}${selectedCompany.id}`;
                    state = "Produto Acabado"
                    stateToUrl = "Stock"
                    console.log("Produto acabado");
                } else if (stateTable === "comppart") {
                    apiUrl = `${DOWNLOADSTOCKCOMPPART}${selectedCompany.id}`;
                    state = "Component_Part"
                    stateToUrl = "Stock"
                } else if (stateTable === "rstocks") {
                    let parameters = {
                        "codarthfa": `&codarthfa_like=${searchByName}`,
                        "description": `&description_like=${searchByName}`,
                        "codartclient": `&customer_part_like=${searchByName}`,
                    }
                    let additionalParameters = parameters[filterBy] || "";
                    let dateFilters = "";
                    if (isDate && filterBy === "dateEp" && dateEpStart && dateEpEnd) {
                        dateFilters = `&date_start=${dateEpStart}&date_end=${dateEpEnd}`;
                    }
                    apiUrl = `${DOWNLOADREPORTSTOCK}${selectedCompany.id}${additionalParameters}${dateFilters}`;
                    state = "report_stock"
                    stateToUrl = "report_Stock"
                    console.log("report stock");
                } else {
                    console.log("close");
                    apiUrl = `${DOWNLOADORDERSOPCLOSED}${selectedCompany.id}`;
                    state = "closed";
                    stateToUrl = "Orders"
                }

                console.log("Request URL:", apiUrl);

                const response = await axios.get(`${apiUrl}&delimiter=${encodeURIComponent(separator)}`, {
                    headers: { Authorization: `token ${token}`, 'Accept-Language': selectedLanguage?.lang },
                    responseType: "blob",
                });

                if (response.status === 200) {
                    const currentDate = new Date().toISOString().slice(0, 10);
                    const extension = separator === "\t" ? "_excel.csv" : ".csv";
                    const filename = `${t(stateToUrl)} ${t(state)} ${selectedCompany?.name} ${currentDate}${extension}`;

                    const blob = new Blob([response.data], { type: "application/octet-stream" });
                    const url = window.URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = url;
                    link.download = filename;
                    link.click();


                    window.URL.revokeObjectURL(url);
                    isRequestInProgress = true
                    setModalWaitShow(false)
                } else if (response.status === 401 && response.data.detail[0] === "Invalid Token") {
                    dispatch(logoutSelectedLink());
                    dispatch(logoutSelectedCompany());
                    dispatch(logoutSelectedMoreCompany());
                    navigate("/pages/LoginPage/");
                    isRequestInProgress = true
                    setModalWaitShow(false)
                } else {
                    isRequestInProgress = true
                    setModalWaitShow(false)
                    throw new Error("Failed to get csv file");
                }
            } catch (error) {
                console.error("Error downloading CSV:", error);
                isRequestInProgress = true
                setModalWaitShow(false)

                toast.error({
                    text: t("csv_download_err"),
                    type: "error",
                });
            } finally {
                setLoading(false)
                isRequestInProgress = true
                setModalWaitShow(false);
            }
        } else {
            console.log("Request already in progress");
            isRequestInProgress = true
            setModalWaitShow(false)
        }
    };

    // Function to fetch orders based on selected link and state
    const getOrdersOpenOrClosed = () => {
        console.log("Fazer pedido");

        if (!stateTable) {
            //console.log("stateTable is required");
            return;  // Return early if stateTable is not defined
        }

        setLoading(true);
        setExpandedRow(null);
        setSubTableData([]);

        let baseParams = `companyid=${selectedCompany?.id}&page=${page}&records_per_page=${ITEMS_PER_PAGE}&available_st_not0=${isChecked}`;
        let baseUrl = `companyid=${selectedCompany?.id}&page=${page}&records_per_page=${ITEMS_PER_PAGE}`;
        let url = "";

        if (selectedLink?.name === "Artigos em Stock") {
            // Decide the filter based on `filterBy` state
            let filterParam = filterBy === "codarthfa" ? `codarthfa_like=${searchByName}`
                : filterBy === "description" ? `description_like=${searchByName}`
                    : filterBy === "codartclient" ? `customer_part_like=${searchByName}`
                        : "";

            let filtersToMp = stateTable === "mp" ? `reserved_st_not0=${isCheckedSecond}&ordered_st_not0=${isCheckedThird}` : "";
            url = `${STOCKGET}${stateTable}/json?${baseParams}&${filterParam}&${filtersToMp}`;

        } else if (selectedLink?.name === "Relatório de Stocks") {

            const parameters = {
                "codarthfa": `codarthfa_like=${searchByName}`,
                "description": `description_like=${searchByName}`,
                "codartclient": `customer_part_like=${searchByName}`,

            }

            const additionalParameters = parameters[filterBy] || "";

            let dateFilters = "";
            if (isDate && filterBy === "dateEp" && dateEpStart && dateEpEnd) {
                dateFilters = `&date_start=${dateEpStart}&date_end=${dateEpEnd}`;
            }

            // Monta a URL
            url = `${GETREPORTSTOCK}${selectedCompany?.id}&page=${page}&records_per_page=${ITEMS_PER_PAGE}&${additionalParameters}${dateFilters}`;

        } else if (selectedLink?.name === "Detalhes do Envio") {
            if (filterBy === "expeditionGuide" && searchByName) {
                url = `${GETEXPEDITIONGUIDEINFO}${selectedCompany?.id}&expedition_guide=${searchByName}`;
            } else {
                // Monta a URL para "Detalhes do Envio"
                let dateFilters = "";
                if (isDate && filterBy === "dateEp" && dateEpStart && dateEpEnd) {
                    dateFilters = `&date_start=${dateEpStart}&date_end=${dateEpEnd}`;
                }
                url = `${GETEXPEDITIONGUIDE}${selectedCompany?.id}&page=${page}&records_per_page=${ITEMS_PER_PAGE}${dateFilters}`;
            }
        } else if (selectedLink?.name === "Manifestos de Carga") {
            if (filterBy === "shipmanif" && searchByName) {
                url = `${GETSHIPMANIFESTINFO}${selectedCompany?.id}&shipment_manifest=${searchByName}`;
            } else {
                // Monta a URL para "Detalhes do Envio"
                let dateFilters = "";
                if (isDate && filterBy === "dateEp" && dateEpStart && dateEpEnd) {
                    dateFilters = `&date_start=${dateEpStart}&date_end=${dateEpEnd}`;
                }
                url = `${GETSHIPMANIFEST}${selectedCompany?.id}&page=${page}&records_per_page=${ITEMS_PER_PAGE}${dateFilters}`;
            }
        }
        else {
            //console.log("aqui");
            const params = {
                "codarthfa": `codarthfa_like=${searchByName}`,
                "num_enc": `num_enc_like=${searchByName}`,
                "cod_req": `codreqcli_like=${searchByName}`,
                "product": `produto_like=${searchByName}`,
                "data_ep_gte": `data_ep_gte=${dateEpStart}`,
            }

            // Ensure that the correct parameter is appended to the base URL
            let additionalParams = params[filterBy] || ""; // This will fetch the correct query based on stateTable or be empty if no matching key.

            // Add additional parameters to the base URL
            let dateFilters = "";
            if (isDate) {
                if (filterBy === "dateEp") {
                    dateFilters = `data_ep_gte=${dateEpStart}&data_ep_lte=${dateEpEnd}`;
                } else if (filterBy === "dateEf") {
                    dateFilters = `data_ef_gte=${dateEfStart}&data_ef_lte=${dateEfEnd}`;
                }
            }


            // Construct the URL
            url = `${ORDEROPENORCLOSED}orders-${stateTable}/json?${baseUrl}&${additionalParams}&${dateFilters}`;
            //console.log("stateTable:", stateTable);  // Check the value of stateTable
            //console.log("Params:", params);  // Check the content of params
            //console.log("Selected additionalParams:", additionalParams);
        }

        console.log(selectedLanguage);
        console.log(url);  // For debugging purposes

        SendRequest("get", url, (successData) => {
            if (successData?.result === "erro") {
                navigate("/pages/LoginPage/");
            } else if (successData?.result?.result?.length === 0 || successData?.result === "erro 400") {
                setInfoTable([]);
                setTotalPages(0);
                setColumnNames([]);
                setLoading(false);
            } else {
                setInfoTable(successData?.result?.result);
                setTotalPages(successData?.result?.num_pages);
                setColumnNames(Object.keys(successData?.result?.result[0]));
                setLoading(false);
            }
        }, (error) => {
            console.log("Error:", error);
        }, dispatch, selectedLanguage);
    };

    // Function to toggle visibility of the information balloon
    const iWantToSee = () => {
        setSeeBalloon(!seeBalloon)
    }

    // Effect to close the information balloon when clicking outside of it
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (balloonRef.current && !balloonRef.current.contains(event.target)) {
                iWantToSee(setSeeBalloon);  // Use the imported function
            }
        };

        // Attach the event listener
        document.addEventListener("mousedown", handleClickOutside);

        // Clean up the event listener on component unmount
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [seeBalloon]);

    // Handle change on select
    const handleChange = (e) => {
        const value = e.target.value;
        setFilterBy(value);

        if (value === "") {
            setSearchByName("");  // This sets searchByName to an empty string
            setIsChecked(0)
        }
    };

    // Effect to make a request when searchByName is cleared
    useEffect(() => {
        if (searchByName === "") {
            getOrdersOpenOrClosed();  // This function is called only after searchByName is cleared
        }
    }, [searchByName]);

    // Effect to reset checkboxes when stateTable is changed
    useEffect(() => {
        setIsChecked(0)
        setIsCheckedSecond(0)
        setIsCheckedThird(0)
        setFilterBy("")
        goToPage(1);
        setSearchByName("");
    }, [stateTable, selectedLink?.name]);


    // Function to manually execute search when dates are valid
    const handleDateSearch = () => {
        let isEffectFetch = false;

        if (filterBy === "dateEp" && dateEpStart && dateEpEnd) {
            if (new Date(dateEpStart) > new Date(dateEpEnd)) {
                toast.error(t("date_picker_err2"));
            } else {
                isEffectFetch = true;
            }
        } else if (filterBy === "dateEf" && dateEfStart && dateEfEnd) {
            if (new Date(dateEfStart) > new Date(dateEfEnd)) {
                toast.error(t("date_picker_err2"));
            } else {
                isEffectFetch = true;
            }
        }

        if (isEffectFetch) {
            setPage(1);
            getOrdersOpenOrClosed();
        }
    };

    // Function to reset the end date
    useEffect(() => {
        setDateEpStart("");
        setDateEpEnd("");
        setDateEfStart("");
        setDateEfEnd("");
    }, [filterBy]);

    return (
        <>
            <ModalWait
                show={modalWaitShow}
                onHide={() => setModalWaitShow(false)}
            />
            {loading ? (
                <div className="loading-spinner">
                    <RingLoader size={100} color={"#123abc"} loading={loading} />
                </div>
            ) : (
                <>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ width: 'fit-content', marginTop: '52px' }}>
                            {selectedLink?.name === "Encomendas" ? (
                                <div className="d-flex mob">
                                    <div className="mob2">
                                        <label>{t('Estado')}</label>
                                        <select style={{ border: '1px solid lightgray' }} value={stateTable} onChange={(e) => setStateTable(e.target.value)}>
                                            <option value="open">{t('Pendente')}</option>
                                            <option value="closed">{t('Satisfeita')}</option>
                                        </select>
                                    </div>
                                    <div className="ml-2 mob3">
                                        <label>{t('Filtrar por')}</label>
                                        <select value={filterBy} onChange={handleChange}>
                                            <option value="">{t('Todos')}</option>
                                            <option value="num_enc">{t('Numero Encomenda HFA')}</option>
                                            <option value="codarthfa">{t('Código Artigo HFA')}</option>
                                            <option value="cod_req">{t('Código Requisição Cliente')}</option>
                                            <option value="product">{t('Produto')}</option>
                                            <option value="dateEp">{t('Data Entrega Prevista')}</option>
                                            <option value="dateEf">{t('Data Entrega Efetiva')}</option>
                                        </select>
                                    </div>
                                    {filterBy !== "" && filterBy !== "dateEp" && filterBy !== "dateEf" ? (
                                        <div className="ml-2 mob3">
                                            <label>{t('Procurar')}</label>
                                            <input
                                                value={searchByName} onChange={(e) => setSearchByName(e.target.value)}
                                                type="text"
                                                placeholder={t('Procurar')} onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        getOrdersOpenOrClosed();
                                                        setPage(1);
                                                    }
                                                }} />
                                        </div>)
                                        :
                                        ""
                                    }
                                    {filterBy === "dateEp" ? (
                                        <>
                                            <div className="ml-2 mob3">
                                                <label>{t('Data Entrega Prevista Inicio')}</label>
                                                <input type="date" value={dateEpStart} onChange={(e) => {
                                                    setIsDate(true)
                                                    setDateEpStart(e.target.value)
                                                }} />
                                            </div>
                                            <div className="ml-2 mob3">
                                                <label>{t('Data Entrega Prevista Fim')}</label>
                                                <input
                                                    type="date"
                                                    value={dateEpEnd}
                                                    onChange={(e) => {
                                                        setIsDate(true);
                                                        setDateEpEnd(e.target.value);
                                                    }}
                                                />
                                            </div>
                                            <div className="ml-2 mob3 d-flex align-items-end pb-1">
                                                <button style={{ height: '34px', padding: '0 15px', backgroundColor: '#002C4B', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={handleDateSearch}>
                                                    {t('Procurar')}
                                                </button>
                                            </div>
                                        </>
                                    ) : filterBy === "dateEf" ? (
                                        <>
                                            <div className="ml-2 mob3">
                                                <label>{t('Data Entrega Efetiva Inicio')}</label>
                                                <input type="date" value={dateEfStart} onChange={(e) => {
                                                    setIsDate(true)
                                                    setDateEfStart(e.target.value)
                                                }} />
                                            </div>
                                            <div className="ml-2 mob3">
                                                <label>{t('Data Entrega Efetiva Fim')}</label>
                                                <input
                                                    type="date"
                                                    value={dateEfEnd}
                                                    onChange={(e) => {
                                                        setIsDate(true);
                                                        setDateEfEnd(e.target.value);
                                                    }}
                                                />
                                            </div>
                                            <div className="ml-2 mob3 d-flex align-items-end pb-1">
                                                <button style={{ height: '34px', padding: '0 15px', backgroundColor: '#002C4B', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={handleDateSearch}>
                                                    {t('Procurar')}
                                                </button>
                                            </div>
                                        </>
                                    ) : ""}
                                </div>
                            ) : selectedLink?.name === "Relatório de Stocks" ? (
                                <div className="d-flex mob">
                                    <div className="mob2">
                                        <label>{t('Tipo')}</label>
                                        <select value={stateTable} onChange={(e) => setStateTable(e.target.value)}>
                                            <option value="mp">{t('Matéria Prima')}</option>
                                            {/* <option value="prodacabado">{t('Produto Acabado')}</option> */}
                                            {/* <option value="comppart">{t('Component Part')}</option> */}
                                        </select>
                                    </div>
                                    <div className="ml-2 mob3">
                                        <label>{t('Filtrar por')}</label>
                                        <select value={filterBy} onChange={handleChange}>
                                            <option value="">{t('Todos')}</option>
                                            <option value="codarthfa">{t('Código Artigo HFA')}</option>
                                            <option value="description">{t('Descrição')}</option>
                                            <option value="codartclient">{t('Cód. Artigo do Cliente')}</option>
                                            <option value="dateEp">{t('Intervalo de Datas')}</option>
                                        </select>
                                    </div>
                                    {filterBy === "dateEp" ? (
                                        <>
                                            <div className="ml-2 mob3">
                                                <label>{t('Data Inicio')}</label>
                                                <input type="date" value={dateEpStart} onChange={(e) => {
                                                    setIsDate(true)
                                                    setDateEpStart(e.target.value)
                                                }} />
                                            </div>
                                            <div className="ml-2 mob3">
                                                <label>{t('Data Fim')}</label>
                                                <input
                                                    type="date"
                                                    value={dateEpEnd}
                                                    onChange={(e) => {
                                                        setIsDate(true);
                                                        setDateEpEnd(e.target.value);
                                                    }}
                                                />
                                            </div>
                                            <div className="ml-2 mob3 d-flex align-items-end pb-1">
                                                <button style={{ height: '34px', padding: '0 15px', backgroundColor: '#002C4B', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={handleDateSearch}>
                                                    {t('Procurar')}
                                                </button>
                                            </div>
                                        </>
                                    ) : filterBy === "" ? (
                                        ""
                                    ) : (
                                        <div className="ml-2 mob3">
                                            <label>{t('Procurar')}</label>
                                            <input
                                                value={searchByName} onChange={(e) => setSearchByName(e.target.value)}
                                                type="text"
                                                placeholder={t('Procurar')} onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        getOrdersOpenOrClosed();
                                                        setPage(1);
                                                    }
                                                }} />
                                        </div>
                                    )}
                                </div>
                            ) : selectedLink?.name === "Detalhes do Envio" ? (
                                <div className="d-flex mob">
                                    <div className="ml-2 mob3">
                                        <label>{t('Filtrar por')}</label>
                                        <select value={filterBy} onChange={handleChange}>
                                            <option value="">{t('Todos')}</option>
                                            <option value="dateEp">{t('Intervalo de Datas')}</option>
                                            <option value="expeditionGuide">{t('Guia de Expedição')}</option>
                                        </select>
                                    </div>
                                    {filterBy === "dateEp" ? (
                                        <>
                                            <div className="ml-2 mob3">
                                                <label>{t('Data Inicio')}</label>
                                                <input type="date" value={dateEpStart} onChange={(e) => {
                                                    setIsDate(true)
                                                    setDateEpStart(e.target.value)
                                                }} />
                                            </div>
                                            <div className="ml-2 mob3">
                                                <label>{t('Data Fim')}</label>
                                                <input
                                                    type="date"
                                                    value={dateEpEnd}
                                                    onChange={(e) => {
                                                        setIsDate(true);
                                                        setDateEpEnd(e.target.value);
                                                    }}
                                                />
                                            </div>
                                            <div className="ml-2 mob3 d-flex align-items-end pb-1">
                                                <button style={{ height: '34px', padding: '0 15px', backgroundColor: '#002C4B', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={handleDateSearch}>
                                                    {t('Procurar')}
                                                </button>
                                            </div>
                                        </>
                                    ) : filterBy === "expeditionGuide" ? (
                                        <div className="ml-2 mob3">
                                            <label>{t('Procurar')}</label>
                                            <input
                                                value={searchByName} onChange={(e) => setSearchByName(e.target.value)}
                                                type="text"
                                                placeholder={t('Procurar')} onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        getOrdersOpenOrClosed();
                                                        setPage(1);
                                                    }
                                                }} />
                                        </div>
                                    ) : null}
                                </div>
                            ) : selectedLink?.name === "Manifestos de Carga" ? (
                                <div className="d-flex mob">
                                    <div className="ml-2 mob3">
                                        <label>{t('Filtrar por')}</label>
                                        <select value={filterBy} onChange={handleChange}>
                                            <option value="">{t('Todos')}</option>
                                            <option value="dateEp">{t('Intervalo de Datas')}</option>
                                            <option value="shipmanif">{t('Manifesto de Expedição')}</option>
                                        </select>
                                    </div>
                                    {filterBy === "dateEp" ? (
                                        <>
                                            <div className="ml-2 mob3">
                                                <label>{t('Data Inicio')}</label>
                                                <input type="date" value={dateEpStart} onChange={(e) => {
                                                    setIsDate(true)
                                                    setDateEpStart(e.target.value)
                                                }} />
                                            </div>
                                            <div className="ml-2 mob3">
                                                <label>{t('Data Fim')}</label>
                                                <input
                                                    type="date"
                                                    value={dateEpEnd}
                                                    onChange={(e) => {
                                                        setIsDate(true);
                                                        setDateEpEnd(e.target.value);
                                                    }}
                                                />
                                            </div>
                                            <div className="ml-2 mob3 d-flex align-items-end pb-1">
                                                <button style={{ height: '34px', padding: '0 15px', backgroundColor: '#002C4B', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={handleDateSearch}>
                                                    {t('Procurar')}
                                                </button>
                                            </div>
                                        </>
                                    ) : filterBy === "shipmanif" ? (
                                        <div className="ml-2 mob3">
                                            <label>{t('Procurar')}</label>
                                            <input
                                                value={searchByName} onChange={(e) => setSearchByName(e.target.value)}
                                                type="text"
                                                placeholder={t('Procurar')} onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        getOrdersOpenOrClosed();
                                                        setPage(1);
                                                    }
                                                }} />
                                        </div>
                                    ) : null}
                                </div>
                            ) : (
                                <div className="d-flex mob">
                                    <div className="mob2">
                                        <label>{t('Tipo')}</label>
                                        <select value={stateTable} onChange={(e) => setStateTable(e.target.value)}>
                                            <option value="mp">{t('Matéria Prima')}</option>
                                            <option value="prodacabado">{t('Produto Acabado')}</option>
                                            <option value="comppart">{t('Component Part')}</option>
                                        </select>
                                    </div>
                                    <div className="ml-2 mob3">
                                        <label>{t('Filtrar por')}</label>
                                        <select value={filterBy} onChange={handleChange}>
                                            <option value="">{t('Todos')}</option>
                                            <option value="codarthfa">{t('Código Artigo HFA')}</option>
                                            <option value="description">{t('Descrição')}</option>
                                            {stateTable === "mp" ? (
                                                <>
                                                    <option value="codartclient">{t('Cód. Artigo do Cliente')}</option>
                                                </>
                                            ) : null}
                                        </select>
                                    </div>
                                    {filterBy === "" ? (
                                        ""
                                    ) : (
                                        <div className="ml-2 mob3">
                                            <label>{t('Procurar')}</label>
                                            <input
                                                value={searchByName} onChange={(e) => setSearchByName(e.target.value)}
                                                type="text"
                                                placeholder={t('Procurar')} onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        getOrdersOpenOrClosed();
                                                        setPage(1);
                                                    }
                                                }} />
                                        </div>
                                    )}
                                    {stateTable === "prodacabado" ? (
                                        <div className="ml-2 d-flex align-items-center flex-row-reverse mob4 mob3">
                                            <label>{t('Incluir Stock Disponivel 0')}</label>
                                            <input
                                                style={{ height: '58.87px', appearance: 'auto', width: '15px', alignItems: 'center', marginRight: '8px' }}
                                                type="checkbox"
                                                defaultChecked={isChecked === 0}
                                                value={isChecked === 0}
                                                onChange={(e) => setIsChecked(e.target.checked ? 0 : 1)}
                                            />
                                        </div>
                                    ) : (
                                        stateTable === "mp" ? (
                                            <div style={{ marginTop: '13px' }} className="d-flex">
                                                <div className="ml-2 d-flex align-items-center flex-row-reverse mob4 mob3">
                                                    <label>{t('Incluir Stock Disponivel 0')}</label>
                                                    <input
                                                        style={{ height: '58.87px', appearance: 'auto', width: '15px', alignItems: 'center', marginRight: '8px' }}
                                                        type="checkbox"
                                                        defaultChecked={isChecked === 0}
                                                        value={isChecked === 0}
                                                        onChange={(e) => setIsChecked(e.target.checked ? 0 : 1)}
                                                    />
                                                </div>
                                                <div className="ml-2 d-flex align-items-center flex-row-reverse mob4 mob3">
                                                    <label>{t('Incluir Stock Reservado 0')}</label>
                                                    <input
                                                        style={{ height: '58.87px', appearance: 'auto', width: '15px', alignItems: 'center', marginRight: '8px' }}
                                                        type="checkbox"
                                                        defaultChecked={isCheckedSecond === 0}
                                                        value={isCheckedSecond === 0}
                                                        onChange={(e) => setIsCheckedSecond(e.target.checked ? 0 : 1)}
                                                    />
                                                </div>
                                                <div className="ml-2 d-flex align-items-center flex-row-reverse mob4 mob3">
                                                    <label>{t('Incluir Stock Encomendado 0')}</label>
                                                    <input
                                                        style={{ height: '58.87px', appearance: 'auto', width: '15px', alignItems: 'center', marginRight: '8px' }}
                                                        type="checkbox"
                                                        defaultChecked={isCheckedThird === 0}
                                                        value={isCheckedThird === 0}
                                                        onChange={(e) => setIsCheckedThird(e.target.checked ? 0 : 1)}
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="ml-2 d-flex align-items-center flex-row-reverse mob4 mob3">
                                                <label>{t('Incluir Stock Disponivel 0')}</label>
                                                <input
                                                    style={{ height: '58.87px', appearance: 'auto', width: '15px', alignItems: 'center', marginRight: '8px' }}
                                                    type="checkbox"
                                                    defaultChecked={isChecked === 0}
                                                    value={isChecked === 0}
                                                    onChange={(e) => setIsChecked(e.target.checked ? 0 : 1)}
                                                />
                                            </div>
                                        )
                                    )}
                                </div>
                            )}
                        </div>
                        <div>
                            <button className="download-btn-interactive" style={{ background: 'none', border: 'none' }} onClick={() => iWantToSee()} onMouseOver={() => iWantToSee()} >
                                <FaInfoCircle color={'blue'} size={ICON_SIZE} />
                            </button>
                            <button className="ml-2 download-btn-interactive" style={{ background: 'none', border: 'none' }} onClick={() => getCsvFileDownload()} disabled={selectedLink?.name === 'Detalhes do Envio' || selectedLink?.name === 'Manifestos de Carga'} hidden={selectedLink?.name === 'Detalhes do Envio' || selectedLink?.name === 'Manifestos de Carga'} title={t('Exportar CSV')}>
                                <FaFileCsv size={ICON_SIZE} />
                            </button>
                            <button className="ml-2 download-btn-interactive" style={{ background: 'none', border: 'none' }} onClick={() => getCsvFileDownload('\t')} disabled={selectedLink?.name === 'Detalhes do Envio' || selectedLink?.name === 'Manifestos de Carga'} hidden={selectedLink?.name === 'Detalhes do Envio' || selectedLink?.name === 'Manifestos de Carga'} title={t('Exportar Excel')}>
                                <FaFileExcel size={ICON_SIZE} color="#1D6F42" />
                            </button>
                            {seeBalloon === true ? (
                                <div ref={balloonRef} className="informationBalloon">
                                    <small>
                                        {articleInformation.map((item) =>
                                            item.state === stateTable ? (
                                                <MessageToUse key={item.label} title={t(item.label)} text={t(item.description)} />
                                            ) : (<></>)
                                        )}
                                    </small>
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                    <>
                        <div className="mt-4" style={{ overflowX: 'auto' }}>
                            <table className="mt-4">
                                <thead style={{ borderBottom: columnNames.length > 0 ? '1px solid lightgray' : "none" }} className="colorHead">
                                    {infoTable.length > 0 ? (
                                        <tr>
                                            {columnNames
                                                .map((columnName) => (
                                                    <th key={columnName}>{columnName}</th>
                                                ))}
                                            {(selectedLink?.name === 'Detalhes do Envio' || selectedLink?.name === 'Manifestos de Carga') && (
                                                <th style={{ whiteSpace: 'nowrap', width: '1%', textAlign: 'center' }}>Download</th>
                                            )}
                                        </tr>
                                    ) : (
                                        <></>
                                    )}
                                </thead>
                                <tbody>
                                    {infoTable.length > 0 ? (
                                        infoTable.map((value, index) => (
                                            <React.Fragment key={value.FACLIId || index}>
                                                <tr style={{ cursor: (selectedLink?.name === "Encomendas" || selectedLink?.name === "Detalhes do Envio" || selectedLink?.name === "Manifestos de Carga") ? 'pointer' : "auto" }} onClick={() => handleRowClick(index, value)} className="tableTr">
                                                    {Object.keys(value)
                                                        .map((key) => (
                                                            <td className="hideText" key={key} title={value[key]}>{value[key]}</td>
                                                        ))}
                                                    {selectedLink?.name === 'Detalhes do Envio' && (() => {
                                                        const expGuide = value["Document"] || value["Documento"] || Object.values(value)[0];
                                                        const isDownloading = downloadingRow === expGuide;
                                                        return (
                                                            <td style={{ padding: '4px 8px', whiteSpace: 'nowrap', width: '1%', textAlign: 'center' }}>
                                                                <button
                                                                    title={t('Exportar CSV')}
                                                                    disabled={isDownloading}
                                                                    style={{ background: 'none', border: 'none', cursor: isDownloading ? 'not-allowed' : 'pointer', padding: '2px 4px' }}
                                                                    onClick={(e) => downloadExpeditionCsv(e, expGuide)}
                                                                >
                                                                    {isDownloading
                                                                        ? <RingLoader size={16} color="#002C4B" />
                                                                        : (
                                                                            <div className="d-flex">
                                                                                <button
                                                                                    title={t('Exportar CSV')}
                                                                                    className="download-btn-interactive"
                                                                                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px' }}
                                                                                    onClick={(e) => downloadExpeditionCsv(e, expGuide, ",")}
                                                                                >
                                                                                    <FaFileCsv size={14} color="#002C4B" />
                                                                                </button>
                                                                                <button
                                                                                    title={t('Exportar Excel')}
                                                                                    className="download-btn-interactive"
                                                                                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px' }}
                                                                                    onClick={(e) => downloadExpeditionCsv(e, expGuide, "\t")}
                                                                                >
                                                                                    <FaFileExcel size={14} color="#1D6F42" />
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                </button>
                                                            </td>
                                                        );
                                                    })()}
                                                    {selectedLink?.name === 'Manifestos de Carga' && (() => {
                                                        const shipManif = value["Manifesto de Carga"] || value["Shipment Manifest"] || Object.values(value)[0];
                                                        const isDownloading = downloadingRow === shipManif;
                                                        return (
                                                            <td style={{ padding: '4px 8px', whiteSpace: 'nowrap', width: '1%', textAlign: 'center' }}>
                                                                <button
                                                                    title={t('Exportar CSV')}
                                                                    disabled={isDownloading}
                                                                    style={{ background: 'none', border: 'none', cursor: isDownloading ? 'not-allowed' : 'pointer', padding: '2px 4px' }}
                                                                    onClick={(e) => downloadShipmentManifestCsv(e, shipManif)}
                                                                >
                                                                    {isDownloading
                                                                        ? <RingLoader size={16} color="#002C4B" />
                                                                        : (
                                                                            <div className="d-flex">
                                                                                <button
                                                                                    title={t('Exportar CSV')}
                                                                                    className="download-btn-interactive"
                                                                                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px' }}
                                                                                    onClick={(e) => downloadShipmentManifestCsv(e, shipManif, ",")}
                                                                                >
                                                                                    <FaFileCsv size={14} color="#002C4B" />
                                                                                </button>
                                                                                <button
                                                                                    title={t('Exportar Excel')}
                                                                                    className="download-btn-interactive"
                                                                                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px' }}
                                                                                    onClick={(e) => downloadShipmentManifestCsv(e, shipManif, "\t")}
                                                                                >
                                                                                    <FaFileExcel size={14} color="#1D6F42" />
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                </button>
                                                            </td>
                                                        );
                                                    })()}
                                                </tr>
                                                {expandedRow === index && (
                                                    <tr
                                                        className="sub-table-row"
                                                        onMouseEnter={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                                        onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                                    >
                                                        <td colSpan={columnNames.length + 1} style={{ padding: 0, color: 'inherit' }}>
                                                            <div style={{ backgroundColor: '#f9f9f9', padding: '10px', margin: '5px' }}>
                                                                {loadingSubTable ? (
                                                                    <div style={{ padding: "20px", textAlign: "center", display: "flex", justifyContent: "center" }}><RingLoader size={40} color={"#123abc"} /></div>
                                                                ) : subTableData && subTableData.length > 0 ? (
                                                                    <div style={{ maxHeight: '380px', overflowY: 'auto', overflowX: 'auto' }}>
                                                                        <table style={{ width: '100%', margin: 0, borderCollapse: 'collapse', boxShadow: '0 0 5px rgba(0,0,0,0.1)' }}>
                                                                            <thead style={{ backgroundColor: '#e9ecef', position: 'sticky', top: 0, zIndex: 1 }}>
                                                                                <tr>
                                                                                    {Object.keys(subTableData[0]).map((subKey) => (
                                                                                        <th key={subKey} style={{ padding: '8px', borderBottom: '2px solid #ddd', textAlign: 'left', fontWeight: 'bold' }}>{subKey}</th>
                                                                                    ))}
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {subTableData.map((subVal, subIdx) => (
                                                                                    <tr key={subIdx} style={{ backgroundColor: subIdx % 2 === 0 ? '#fff' : '#f5f5f5', borderBottom: '1px solid #eee', color: '#333' }}>
                                                                                        {Object.keys(subVal).map((subKey) => (
                                                                                            <td key={subKey} style={{ padding: '8px', border: 'none', whiteSpace: 'nowrap' }}>{subVal[subKey] !== null ? String(subVal[subKey]) : ''}</td>
                                                                                        ))}
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                ) : (
                                                                    <div style={{ padding: "10px", textAlign: "center", color: '#333' }}>{t("No_data_available")}</div>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="test2"></td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            {infoTable.length > 0 ? (
                                <div className="d-flex justify-content-flex-end align-items-center mt-1">
                                    <span
                                        style={{
                                            borderRight: "1px solid lightgray",
                                            paddingRight: "32px",
                                            marginRight: "32px",
                                        }}
                                    >
                                        Página {page} of {totalPages}
                                    </span>
                                    <button className="btnTable" onClick={() => goToPage(page - 1)}>
                                        <BiLeftArrow size={ICON_SIZE} />
                                    </button>
                                    <button
                                        className="btnTable"
                                        style={{
                                            marginRight: "32px",
                                        }}
                                        onClick={() => goToPage(page + 1)}
                                    >
                                        <BiRightArrow size={ICON_SIZE} />
                                    </button>
                                    <input
                                        style={{ width: "64px" }}
                                        type="number"
                                        value={page}
                                        onChange={(e) => setPage(parseInt(e.target.value, 10))}
                                    />
                                </div>
                            ) : (<></>)}
                        </div>
                    </>
                </>
            )
            }
        </>
    );
}

export default TableToUse;
